var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrn8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 349,
    viewBox: "0 0 208 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.849 242.164C371.99 154.018 330.625 51.7671 242.164 14.4929C154.019 -22.6481 51.7676 18.7167 14.4934 107.178C-22.7808 195.639 18.7172 297.574 107.178 334.848C195.456 371.674 297.708 330.309 334.849 242.164ZM299.78 227.387C270.627 296.576 190.828 328.801 121.955 299.78C52.7656 270.626 20.5413 190.828 49.5619 121.954C78.7157 52.7651 158.514 20.5408 227.388 49.5614C296.71 78.3993 328.934 158.198 299.78 227.387Z",
    fill: "url(#paint0_linear_80_39)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_39",
    x1: -34.779,
    y1: 224.114,
    x2: 294.391,
    y2: 338.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#129106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EBF4E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrn8);
export default __webpack_public_path__ + "static/media/orn8.3baa36ebba085732f20ddc81ce347f67.svg";
export { ForwardRef as ReactComponent };